import { render, staticRenderFns } from "./BookingsPagination.vue?vue&type=template&id=454ac400&lang=pug&"
import script from "./BookingsPagination.vue?vue&type=script&lang=js&"
export * from "./BookingsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports